import { getImgDomain } from '@/assets/api/token.js';

export function newproxy(obj) {
  const str = JSON.stringify(obj);
  var reg = /domainUrlPrefix/g;
  var ToReplace = JSON.parse(getImgDomain());
  let replaceStr = str.replace(reg, ToReplace);
  const newObj = JSON.parse(replaceStr);
  return newObj;
}

export function newproxyPut(obj) {
  let str = '';
  if (obj) {
    str = typeof obj === 'object' && JSON.stringify(obj);
  }
  const baseUrl = JSON.parse(getImgDomain());
  var ToReplace = 'domainUrlPrefix';
  const escapedBaseUrl =
    baseUrl && baseUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const reg = new RegExp(escapedBaseUrl, 'g'); // 全局匹配

  let replaceStr = str != '' && str.replace(reg, ToReplace);
  const newObj = JSON.parse(replaceStr);
  return newObj;
}
